import { Colors } from '@src/colors';
import styled from 'styled-components';

export const Input = styled.input`
    font-family: 'Public Sans';
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    color: ${Colors.dusk};

    padding: 13px 20px;

    box-sizing: border-box;

    background: ${Colors.white};
    border: 1px solid ${Colors.midnight70};
    border-radius: 8px;

    height: 50px;

    &:disabled {
        background: ${Colors.grayEight};
        color: ${Colors.duskTwo};
        cursor: default;
        &:hover,
        &:active {
            background: ${Colors.grayEight};
        }
    }

    &:hover {
        background: ${Colors.midnight2};
    }

    &:active {
        background: ${Colors.midnight4};
    }
`;
